import axios from 'axios'
import APIConfig from '@/assets/js/data/remote/APIConfig.js'
import config from '@/assets/js/config.js'

export class UserService {
  constructor (passwordCrypter) {
    this.passwordCrypter = passwordCrypter
    this.apis = {
      getAll: () => axios.get(APIConfig.BPIURL + '/user'),
      add: (payload) => axios.post(APIConfig.BPIURL + '/user', payload),
      edit: (id, payload) => axios.put(APIConfig.BPIURL + `/user/${id}`, payload),
      delete: (id) => axios.delete(APIConfig.BPIURL + `/user/${id}`),
      inActivate: (id) => axios.post(APIConfig.BPIURL + `/user/${id}/inactivate`),
      getUsersDetail: (ids) => axios.get(APIConfig.BPIURL + '/users/detail?ids=' + JSON.stringify(ids)),
      getUserOrders: (id) => axios.get(APIConfig.BPIURL + `/user/${id}/order`),
      getUserVouchers: (id) => axios.get(APIConfig.BPIURL + `/user/${id}/voucher`),
      updateUesrProfile: (userID, payload) => axios.put(APIConfig.BPIURL + `/user/${userID}/profile`, payload),
      resetPassword: (id) => axios.post(APIConfig.BPIURL + `/user/${id}/reset-password`)
    }

    // fake data
    if (config.useFakeData) {
      this.apis = {
        getAll: () => new Promise((resolve, reject) => {
          var res = {
            data: {
              status: 'ok',
              result: []
            }
          }
          resolve(res)
        })
      }
    }
  }

  fetchDatas (vm) {
    return this.getAll(vm).then(res => {
      vm.$store.state.user.list = res.data.result
    })
  }

  getAll (vm) {
    vm.isLoading = true
    return this.apis.getAll()
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  add (vm, payload) {
    vm.isLoading = true
    payload.user.Password = this.passwordCrypter.cryptPassword(payload.user.Password)
    return this.apis.add(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  edit (vm, id, payload) {
    vm.isLoading = true
    return this.apis.edit(id, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  delete (vm, id) {
    vm.isLoading = true
    return this.apis.delete(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  inActivate (vm, id) {
    vm.isLoading = true
    return this.apis.inActivate(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  // custom
  getUsersDetail (vm, ids) {
    vm.isLoading = true
    return this.apis.getUsersDetail(ids)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  getUserOrders (vm, id) {
    vm.isLoading = true
    return this.apis.getUserOrders(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  getUserVouchers (vm, id) {
    vm.isLoading = true
    return this.apis.getUserVouchers(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  updateUesrProfile (vm, userID, payload) {
    vm.isLoading = true
    return this.apis.updateUesrProfile(userID, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  resetPassword (vm, userID) {
    vm.isLoading = true
    return this.apis.resetPassword(userID)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}

export class UserGiftVoucherService {
  constructor () {
    this.apis = {
      getAll: () => axios.get(APIConfig.BPIURL + '/userGiftVoucher'),
      add: (payload) => axios.post(APIConfig.BPIURL + '/userGiftVoucher', payload),
      edit: (id, payload) => axios.put(APIConfig.BPIURL + `/userGiftVoucher/${id}`, payload),
      delete: (id) => axios.delete(APIConfig.BPIURL + `/userGiftVoucher/${id}`)
    }

    // fake data
    if (config.useFakeData) {
      this.apis = {
        getAll: () => new Promise((resolve, reject) => {
          var res = {
            data: {
              status: 'ok',
              result: []
            }
          }
          resolve(res)
        })
      }
    }
  }

  getAll (vm) {
    vm.isLoading = true
    return this.apis.getAll()
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  add (vm, payload) {
    vm.isLoading = true
    return this.apis.add(payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  edit (vm, payload) {
    vm.isLoading = true
    return this.apis.edit(payload.ID, payload)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }

  delete (vm, id) {
    vm.isLoading = true
    return this.apis.delete(id)
      .then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (!ok) throw (res && res.data && res.data.error) || '未知的錯誤'
        return res
      })
      .finally(() => {
        vm.isLoading = false
      })
  }
}
